



















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { EnquiryProduct } from '@/models/enquiry-product';
import { QuoteApi } from '@/api/quote-api';
import { Enquiry } from '@/models/enquiry';
import { QuoteProduct } from '@/models/quote-product';
import { Quote } from '@/models/quote';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
// eslint-disable-next-line camelcase
import { required, numeric, min_value } from 'vee-validate/dist/rules';
// @ts-ignore
import { messages } from 'vee-validate/dist/locale/en.json';

extend('required', { ...required, message: messages['required'] });

extend('numeric', { ...numeric, message: messages['numeric'] });
// eslint-disable-next-line camelcase
extend('min_value', { ...min_value, message: messages['min_value'] });

const quoteApi = new QuoteApi();

@Component({
    components: {
        ValidationProvider,
        ValidationObserver,
    },
})
export default class QuoteForm extends Vue {
    @Prop({ required: true }) public enquiry: Enquiry;
    private keyIndex: number = 0;
    public quoteIdentifier: string | null = null;
    public enquiryProducts: Array<EnquiryProduct> = this.enquiry.products;
    public products: Array<QuoteProduct> = new Array<QuoteProduct>(...this.enquiry.products.map((p) => {
        return { key: ++this.keyIndex, productNumber: p.productNumber, description: p.description, quantity: p.quantity, supplier: p.supplier, partNumber: p.partNumber, price: p.price };
    }));

    public get total(): number {
        return this.products.reduce((total: number, product: QuoteProduct) => {
            return total + (Number(product.price) * Number(product.quantity) || 0);
        }, 0);
    }

    public AddProduct(): void {
        this.products.push({ key: ++this.keyIndex, productNumber: null, description: null, quantity: 0, supplier: null, partNumber: null, price: null });
    }
    public RemoveProduct(index: number): void {
        this.products.splice(index, 1);
    }
    public async Save(): Promise<void> {
        const quote: Quote = {
            quoteIdentifier: this.quoteIdentifier,
            status: 0,
            price: this.total,
            enquiryId: this.enquiry.id!,
            products: this.products,
        };

        const id = await quoteApi.createAsync(quote);

        this.$emit('quote-saved', id);
    }
}
